import swal from 'sweetalert2';

export default {
    methods: {
        swal({
            title = 'Success',
            text = 'Operation has successfully completed',
            html = '',
            type = 'success',
            confirmButtonText = 'Close',
        } = {}) {
            swal({
                title,
                text,
                type,
                html,
                confirmButtonText,
            });
        },

        swalError({
            title = 'Error',
            text = 'An error occurred',
            html = '',
            type = 'error',
            confirmButtonText = 'Close',
        } = {}) {
            swal({
                title,
                text,
                type,
                html,
                confirmButtonText,
            });
        },

        swalWarning({
            title = 'Invalid',
            text = 'Unable to proceed',
            html = '',
            type = 'warning',
            confirmButtonText = 'Close',
        } = {}) {
            swal({
                title,
                text,
                type,
                html,
                confirmButtonText,
            });
        },

        async swalAjaxConfirmation({
            title = 'Are you sure?',
            confirmText = 'Yes',
            text = '',
            onSuccess = () => {},
            confirmButtonColor = '#dc3545',
            type = null,
            url = null,
            method = 'put',
            params = {},
            preConfirm = null,
            onError = () => {},
            onCancel = () => {},
        } = {}) {
            const options = {
                title,
                text,
                type,
                showCancelButton: true,
                confirmButtonColor,
                cancelButtonColor: '#eee',
                cancelButtonClass: 'text-dark',
                confirmButtonText: confirmText,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    if (preConfirm !== null) return preConfirm();

                    return axios[method](url, params);
                },
                allowOutsideClick: false,
            };

            try {
                const result = await swal(options);

                if (result.value) {
                    onSuccess(result);
                } else if (result.dismiss == 'cancel') {
                    onCancel(result);
                }
            } catch (e) {
                onError(e);
            }
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/swal.js